import React, { createContext, useContext, useState } from 'react';

const PricingStrategyContext = createContext();

export const PricingStrategyProvider = ({ children }) => {
    const [currentPricingStrategy, setCurrentPricingStrategy] = useState(null);
    const [currentAppId, setCurrentAppId] = useState(null);
    const [currentPlan, setCurrentPlan] = useState(null);
    const [currentTargetUser, setCurrentTargetUser] = useState(null);


    return (
        <PricingStrategyContext.Provider
            value={{
                currentPricingStrategy,
                setCurrentPricingStrategy,
                currentAppId,
                setCurrentAppId,
                currentPlan,
                setCurrentPlan,
                currentTargetUser,
                setCurrentTargetUser,
            }}
        >
            {children}
        </PricingStrategyContext.Provider>
    );
};

export const usePricingStrategy = () => useContext(PricingStrategyContext);
